Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = recentSearchesReducer;

var _constants = require('../constants');

function recentSearchesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  if (action.type === _constants.RECENT_SEARCHES_SUCCESS) {
    return {
      error: null,
      data: action.data
    };
  } else if (action.type === _constants.RECENT_SEARCHES_ERROR) {
    return {
      error: action.error
    };
  }

  return state;
}